import * as React from 'react';
import { UserState } from 'app/reducers/state';
import { API_CHARTBACK, executeQueryGetAuth } from 'app/utils/api';
import { Spinner, Callout, Intent, Button, H3 } from '@blueprintjs/core';
import { find, each } from 'lodash';
import ReactTable from 'react-table';
import { Score } from '../Score';
import { CSVLink } from "react-csv";
import { DoneMarker } from '../DoneMarker';
import { NotDoneMarker } from '../NotDoneMarker';
import * as superagent from 'superagent';
import { wasTutorialModuleCompleted } from '../../utils/scores';
import { SingleOverviewClassic } from '../SingleOverviewClassic';

const STUDENT_NAME_STYLE = {
    color: 'blue',
    cursor: 'pointer'
}

interface Props {
    user: UserState;
    showProfessors?: boolean; // If this is missing, assume that we shouldn't
    selectedClass?: string;
};

interface State {
    loadingClassData: boolean;
    loadingStudentData: boolean;
    classEnrollment: any;
    classDetails: ClassDetails;
    studentDataSet: {};
    selectedStudent: string | undefined;
    downloadDataHolder: any;
}

interface ClassDetails {
    class?: string;
    code?: string;
    id?: string;
    school?: string;
}

export class ClassOverviewClassic extends React.Component<Props, State> {

    state: State = {
        loadingClassData: true,
        loadingStudentData: true,
        classEnrollment: {},
        classDetails: {},
        studentDataSet: {},
        selectedStudent: undefined,
        downloadDataHolder: []
    }
    tableRef05: ReactTable<unknown> | null | undefined | any;
    tableRef04: ReactTable<unknown> | null | undefined | any;
    tableRef03: ReactTable<unknown> | null | undefined | any;
    tableRef02: ReactTable<unknown> | null | undefined | any;
    tableRef01: ReactTable<unknown> | null | undefined | any;
    csvLink: any;

    componentDidMount() {
        this.initClassData();
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.selectedClass !== undefined && this.props.selectedClass !== undefined) {
            if (prevProps.selectedClass !== this.props.selectedClass) {
                this.initClassData();
            }
        }
    }

    initClassData = () => {
        this.setState({
            loadingClassData: true,
            loadingStudentData: true,
            classEnrollment: {},
            classDetails: {},
            studentDataSet: {},
            selectedStudent: undefined,
            downloadDataHolder: []
        });

        const classID = this.getClassID();

        executeQueryGetAuth("class/" + classID.toString() + "/details", {}, this.props.user, (classDetailsResponse) => {
            const classDetails = classDetailsResponse.body;

            executeQueryGetAuth("class/" + classID.toString() + "/students", {}, this.props.user, (response) => {

                let classEnrollmentBase: any[] = [];

                if (this.props.user.level === 3) {
                    classEnrollmentBase = response.body;
                }
                else {
                    each(response.body, en => {
                        if (en.level === 1) {
                            classEnrollmentBase.push(en);
                        }
                    })
                }

                this.setState({
                    loadingClassData: false
                });

                let allStudentIds = [];

                // Now Load all the students
                each(response.body, student => {
                    const studentID = student["id"];

                    //@ts-ignore
                    allStudentIds.push(studentID);
                });

                superagent.
                    get(API_CHARTBACK() + '?userIDSet=' + allStudentIds.join(",") + '&mock=progress_overview_all').
                    end((error: any, response: any) => {
                        let responses = [];

                        for (let i = 0; i < response.body.userData.length; i++) {
                            const binID = response.body.userData[i]['user'];
                            const binDATA = response.body.userData[i]['data'];

                            //@ts-ignore
                            responses.push({
                                id: binID, payload: binDATA
                            })
                        }

                        let result = responses;

                        classEnrollmentBase = classEnrollmentBase.sort((a, b) => {
                            if (a === b) {
                                return 0;
                            }

                            return a.last.toUpperCase() > b.last.toUpperCase() ? 1 : -1;
                        });

                        for (let i = 0; i < classEnrollmentBase.length; i++) {
                            const studentID = classEnrollmentBase[i]["id"];

                            let previousStudent = i - 1;
                            let nextStudent = i + 1;

                            if (nextStudent >= classEnrollmentBase.length) {
                                nextStudent = 0;
                            }

                            if (previousStudent < 0) {
                                previousStudent = classEnrollmentBase.length - 1;
                            }

                            classEnrollmentBase[i]["nextStudentID"] = classEnrollmentBase[nextStudent]["id"];
                            classEnrollmentBase[i]["previousStudentID"] = classEnrollmentBase[previousStudent]["id"];

                            for (let c = 0; c < result.length; c++) {
                                if (studentID.toString() === result[c]["id"]) {
                                    classEnrollmentBase[i]["overview"] = result[c].payload;
                                }
                            }
                        }

                        this.setState({
                            loadingStudentData: false,
                            classEnrollment: classEnrollmentBase,
                            classDetails
                        });
                    });
            });
        });
    }

    getClassID = () => {
        const {
            selectedClass,
            user
        } = this.props;

        if (selectedClass === undefined) {
            return user.class;
        }

        return selectedClass;
    }

    getScenarioBestScore = (scenarioOverview: any) => {
        if (scenarioOverview === undefined) return "";

        if (scenarioOverview["best-score"] === "" || scenarioOverview["best-score"] === undefined || scenarioOverview["best-score"] === "0") {
            return "Not Played";
        }
        const bestScore = parseFloat(scenarioOverview["best-score"]);

        return Math.round(bestScore).toString();
    }

    getScenarioInitilalScore = (scenarioOverview: any) => {
        if (scenarioOverview === undefined) return "";

        if (scenarioOverview["best-score"] === "" || scenarioOverview["best-score"] === undefined || scenarioOverview["best-score"] === "0") {
            return "Not Played";
        }

        const bestScore = parseFloat(scenarioOverview["initial-score"]);

        return Math.round(bestScore).toString();
    }

    getExportData = () => {
        const {
            classEnrollment
        } = this.state;

        let dataBuffer: any[] = [];

        each(classEnrollment, classEnrolle => {

            const scene_2_bc = this.getStudentOverview("scene_2_bc", classEnrolle["id"]);
            const scene_1_bc = this.getStudentOverview("scene_1_bc", classEnrolle["id"]);
            const scene_4_bc = this.getStudentOverview("scene_4_bc", classEnrolle["id"]);

            let isTutorialFinished = wasTutorialModuleCompleted(scene_1_bc, scene_2_bc, scene_4_bc);

            dataBuffer.push({
                "Name": classEnrolle["first"] + " " + classEnrolle["last"],
                "Email": classEnrolle["email"],
                "Purchased": (classEnrolle["subscription"] === 1) ? "Yes" : "No",
                "Completed Intent-based Communication": (isTutorialFinished) ? "Yes" : "No",
                "Scenario 1 Initial Play": this.getScenarioInitilalScore(classEnrolle["overview"]["classic_scenario_1_initial"]),
                "Scenario 1 Best Explore Play": this.getScenarioBestScore(classEnrolle["overview"]["classic_scenario_1"]),
                "Scenario 1 Best Assess Play": this.getScenarioBestScore(classEnrolle["overview"]["classic_scenario_1_assess"]),
                "Scenario 2 Initial Play": this.getScenarioInitilalScore(classEnrolle["overview"]["classic_scenario_2_initial"]),
                "Scenario 2 Best Explore Play": this.getScenarioBestScore(classEnrolle["overview"]["classic_scenario_2"]),
                "Scenario 2 Best Assess Play": this.getScenarioBestScore(classEnrolle["overview"]["classic_scenario_2_assess"]),
                "Scenario 3 Initial Play": this.getScenarioInitilalScore(classEnrolle["overview"]["classic_scenario_3_initial"]),
                "Scenario 3 Best Explore Play": this.getScenarioBestScore(classEnrolle["overview"]["classic_scenario_3"]),
                "Scenario 3 Best Assess Play": this.getScenarioBestScore(classEnrolle["overview"]["classic_scenario_3_assess"]),
                "Scenario 5 Initial Play": this.getScenarioInitilalScore(classEnrolle["overview"]["classic_scenario_5_initial"]),
                "Scenario 5 Best Explore Play": this.getScenarioBestScore(classEnrolle["overview"]["classic_scenario_5"]),
                "Scenario 5 Best Assess Play": this.getScenarioBestScore(classEnrolle["overview"]["classic_scenario_5_assess"])
            });
        })

        return dataBuffer;
    }

    handlePreviousStudent = () => {
        const {
            classEnrollment,
            selectedStudent
        } = this.state;

        const matchingStudent = find(classEnrollment, student => {
            return student.id === selectedStudent
        });

        this.setState({
            selectedStudent: matchingStudent.previousStudentID
        });
    }

    handleNextStudent = () => {
        const {
            classEnrollment,
            selectedStudent
        } = this.state;

        const matchingStudent = find(classEnrollment, student => {
            return student.id === selectedStudent
        });

        this.setState({
            selectedStudent: matchingStudent.nextStudentID
        });
    }

    selectStudent = (student: any) => {
        this.setState({
            selectedStudent: student
        });
    }

    getStudentOverview = (scenario: string, studentID: string) => {
        const {
            classEnrollment
        } = this.state;

        const matchingStudent = find(classEnrollment, student => {
            return student.id === studentID
        });

        return matchingStudent["overview"][scenario];
    }

    getStudentTableColumns = () => {
        const {
            classEnrollment
        } = this.state;

        return [{
            Header: "Student",
            accessor: "id",
            Cell: (props) => {
                const studentID = props.value;

                const student = find(classEnrollment, enrollmentEntry => {
                    return enrollmentEntry.id === studentID
                });

                return <span style={STUDENT_NAME_STYLE} onClick={() => {
                    this.selectStudent(props.value);
                }}>
                    {student.first + " " + student.last}
                </span>
            },
            sortMethod: (a, b) => {
                if (a === b) {
                    return 0;
                }

                const student = find(classEnrollment, enrollmentEntry => {
                    return enrollmentEntry.id === a
                });

                const student2 = find(classEnrollment, enrollmentEntry => {
                    return enrollmentEntry.id === b
                });

                return student.last.toUpperCase() > student2.last.toUpperCase() ? 1 : -1;
            }
        }, {
            Header: "Email",
            accessor: "email"
        }, {
            Header: "Purchased",
            accessor: "subscription",
            Cell: (props) => {
                return (props.value === 1) ? <DoneMarker /> : <NotDoneMarker />
            }
        }, {
            Header: "Finished Intent-based Communication",
            accessor: "id",
            Cell: (props) => {
                const scene_1_bc = this.getStudentOverview("scene_1_bc", props.value);
                const scene_2_bc = this.getStudentOverview("scene_2_bc", props.value);
                const scene_4_bc = this.getStudentOverview("scene_4_bc", props.value);

                let isFinished = wasTutorialModuleCompleted(scene_1_bc, scene_2_bc, scene_4_bc);

                return (isFinished) ? <DoneMarker /> : <NotDoneMarker />
            }
        }];
    }

    getTutorialColumns = () => {
        const {
            classEnrollment
        } = this.state;

        return [{
            Header: "Student",
            accessor: "id",
            Cell: (props) => {
                const studentID = props.value;

                const student = find(classEnrollment, enrollmentEntry => {
                    return enrollmentEntry.id === studentID
                });

                return <span style={STUDENT_NAME_STYLE} onClick={() => {
                    this.selectStudent(props.value);
                }}>
                    {student.first + " " + student.last}
                </span>
            },
            sortMethod: (a, b) => {
                if (a === b) {
                    return 0;
                }

                const student = find(classEnrollment, enrollmentEntry => {
                    return enrollmentEntry.id === a
                });

                const student2 = find(classEnrollment, enrollmentEntry => {
                    return enrollmentEntry.id === b
                });

                return student.last.toUpperCase() > student2.last.toUpperCase() ? 1 : -1;
            }
        }, {
            Header: "Email",
            accessor: "email"
        }, {
            Header: "Getting Work Done",
            accessor: "id",
            Cell: (props) => {
                const overview = this.getStudentOverview("scene_1_bc", props.value);

                if (overview === undefined) {
                    return <NotDoneMarker />
                }

                const bestScoreAsFloat = parseFloat(overview['best-score']);

                if (bestScoreAsFloat === 100.0) {
                    return <DoneMarker />
                }

                return <NotDoneMarker />
            }
        }, {
            Header: "Getting Access to Hidden Ideas",
            accessor: "id",
            Cell: (props) => {
                const overview = this.getStudentOverview("scene_2_bc", props.value);

                if (overview === undefined) {
                    return <NotDoneMarker />
                }

                const bestScoreAsFloat = parseFloat(overview['best-score']);

                if (bestScoreAsFloat === 100.0) {
                    return <DoneMarker />
                }

                return <NotDoneMarker />
            }
        }, {
            Header: "Getting Commitment",
            accessor: "id",
            Cell: (props) => {
                const overview = this.getStudentOverview("scene_4_bc", props.value);

                if (overview === undefined) {
                    return <NotDoneMarker />
                }

                const bestScoreAsFloat = parseFloat(overview['best-score']);

                if (bestScoreAsFloat === 100.0) {
                    return <DoneMarker />
                }

                return <NotDoneMarker />
            }
        }];
    }

    getStudentTableColumnsForScenarios = (baseScenario: string) => {
        const {
            classEnrollment
        } = this.state;

        if (baseScenario === "tutorial") {
            return this.getTutorialColumns();
        }

        return [{
            Header: "Student",
            accessor: "id",
            Cell: (props) => {
                const studentID = props.value;

                const student = find(classEnrollment, enrollmentEntry => {
                    return enrollmentEntry.id === studentID
                });

                return <span style={STUDENT_NAME_STYLE} onClick={() => {
                    this.selectStudent(props.value);
                }}>
                    {student.first + " " + student.last}
                </span>
            },
            sortMethod: (a, b) => {
                if (a === b) {
                    return 0;
                }

                const student = find(classEnrollment, enrollmentEntry => {
                    return enrollmentEntry.id === a
                });

                const student2 = find(classEnrollment, enrollmentEntry => {
                    return enrollmentEntry.id === b
                });

                return student.last.toUpperCase() > student2.last.toUpperCase() ? 1 : -1;
            }
        }, {
            Header: "Email",
            accessor: "email"
        }, {
            Header: "Initial Explore Play",
            accessor: "id",
            Cell: (props) => {

                const overview = this.getStudentOverview(baseScenario + "_initial", props.value);

                if (overview === undefined) return <span>-</span>

                return <Score score={overview['initial-score']} base={overview['best-max']} />
            }
        }, {
            Header: "Best Explore Play",
            accessor: "id",
            Cell: (props) => {
                const overview = this.getStudentOverview(baseScenario, props.value);

                if (overview === undefined) return '';

                return <Score score={overview['best-score']} base={overview['best-max']} />
            }
        }, {
            Header: "Best Assess Play",
            accessor: "id",
            Cell: (props) => {
                const overview = this.getStudentOverview(baseScenario + "_assess", props.value);

                if (overview === undefined) return '';

                return <Score score={overview['best-score']} base={overview['best-max']} />
            }
        }];
    }

    renderCalloutTitle = (title: string, ref: any): any => {
        const {
            classDetails
        } = this.state;

        const showButton = title.includes("Your");

        return <span>
            {title}
            <span style={{ marginLeft: '5px' }}>
                {showButton ?
                    <Button text="Download Data" onClick={() => {
                        this.setState({
                            downloadDataHolder: this.getExportData()
                        }, () => {
                            this.csvLink.link.click();
                        });
                    }} /> : undefined}
                <CSVLink style={{ display: 'none' }} ref={(r) => this.csvLink = r} filename={classDetails.class!.replace(" ", "-") + "-data.csv"} data={this.state.downloadDataHolder} target="_blank">Download Data</CSVLink>
            </span>
        </span>
    }

    renderNavigation = () => {
        const {
            user
        } = this.props;

        if (user.level === 1) return undefined;

        return <span>
            <Button style={{ marginBottom: '10px', marginRight: '10px', marginLeft: '10px' }} intent={Intent.PRIMARY} text="Previous Student" onClick={() => {
                this.handlePreviousStudent();
            }} />

            <Button style={{ marginBottom: '10px' }} intent={Intent.PRIMARY} text="Next Student" onClick={() => {
                this.handleNextStudent();
            }} />
        </span>
    }

    render() {
        const {
            loadingClassData,
            loadingStudentData,
            classEnrollment,
            selectedStudent,
            classDetails
        } = this.state;

        if (loadingClassData || loadingStudentData) return <Spinner />

        if (selectedStudent !== undefined) {

            const matchingStudent = find(classEnrollment, student => {
                return student.id === selectedStudent
            });

            return <span>
                <Button style={{ marginBottom: '10px' }} intent={Intent.PRIMARY} text="Back" onClick={() => {
                    this.selectStudent(undefined);
                }} />
                {this.renderNavigation()}
                {/* <TextAreaV2 /> // TODO MAKE THIS THE COACHING BLOCK */}
                <H3>{matchingStudent.first + " " + matchingStudent.last}'s Overview</H3>
                <SingleOverviewClassic targetUserData={matchingStudent} userTutorial={matchingStudent['tutorial']} goToNext={this.handleNextStudent} goToPrevious={this.handlePreviousStudent} showNavigation={true} hideDownloadPrompt={true} user={this.props.user} forceNoEdit={true} targetUserID={selectedStudent} />
            </span>
        }

        return <span>
            <Callout style={{ marginBottom: '20px' }} icon={"info-sign"} intent={Intent.NONE} title={classDetails.class}>
                <b>Class Name:</b> {classDetails.class}
                <br />
                <b>Class School:</b> {classDetails.school}
                <br />
                <b>Class Invite Code:</b> {classDetails.code}
            </Callout>
            <Callout title={this.renderCalloutTitle("Your Students", this.tableRef01)}>
                <ReactTable ref={(r) => this.tableRef01 = r} data={classEnrollment} pageSize={classEnrollment.length} showPageSizeOptions={false} showPagination={false} columns={this.getStudentTableColumns()} defaultSorted={[{
                    id: 'id',
                    desc: false,
                }]} />
            </Callout>

            <Callout title={this.renderCalloutTitle("Module 1: Intent-based Communication", this.tableRef04)}>
                <ReactTable ref={(r) => this.tableRef04 = r} data={classEnrollment} sortable={true} pageSize={classEnrollment.length} showPageSizeOptions={false} showPagination={false} columns={this.getStudentTableColumnsForScenarios("tutorial")} defaultSorted={[{
                    id: 'id',
                    desc: false,
                }]} />
            </Callout>x

            <Callout title={this.renderCalloutTitle("Module 2: Transforming Relationships", this.tableRef02)}>
                <ReactTable ref={(r) => this.tableRef02 = r} data={classEnrollment} sortable={true} pageSize={classEnrollment.length} showPageSizeOptions={false} showPagination={false} columns={this.getStudentTableColumnsForScenarios("classic_scenario_1")} defaultSorted={[{
                    id: 'id',
                    desc: false,
                }]} />
            </Callout>

            <Callout title={this.renderCalloutTitle("Module 3: Opportunities in Conflict", this.tableRef03)}>
                <ReactTable ref={(r) => this.tableRef03 = r} data={classEnrollment} sortable={true} pageSize={classEnrollment.length} showPageSizeOptions={false} showPagination={false} columns={this.getStudentTableColumnsForScenarios("classic_scenario_2")} defaultSorted={[{
                    id: 'id',
                    desc: false,
                }]} />
            </Callout>

            <Callout title={this.renderCalloutTitle("Module 4: Facilitating Change", this.tableRef04)}>
                <ReactTable ref={(r) => this.tableRef04 = r} data={classEnrollment} sortable={true} pageSize={classEnrollment.length} showPageSizeOptions={false} showPagination={false} columns={this.getStudentTableColumnsForScenarios("classic_scenario_3")} defaultSorted={[{
                    id: 'id',
                    desc: false,
                }]} />
            </Callout>

            <Callout title={this.renderCalloutTitle("Module 5: Crisis and Opportunity", this.tableRef05)}>
                <ReactTable ref={(r) => this.tableRef05 = r} data={classEnrollment} sortable={true} pageSize={classEnrollment.length} showPageSizeOptions={false} showPagination={false} columns={this.getStudentTableColumnsForScenarios("classic_scenario_5")} defaultSorted={[{
                    id: 'id',
                    desc: false,
                }]} />
            </Callout>
        </span>
    }
}
